import { useEffect } from 'react';
import { useLastLocation } from 'react-router-last-location';

import { isSubmenuItemType, ITEM_TYPE } from '../lib';
import { useMainActions } from '../store';

export const useAutoExpandActiveMenuItem = (navigationItems, activePath) => {
  const lastLocation = useLastLocation();
  const mainActions = useMainActions();

  const currentPathname = activePath?.split('?')?.[0];
  const lastPathname = lastLocation?.pathname;

  // Items with types "link", "menu", "collapse" are clickable
  //  link|menu
  //  menu -> link|collapse
  //    collapse -> link
  useEffect(() => {
    navigationItems.forEach((navItem) => {
      // Following logic cares only about "menu" items
      if (navItem.type !== ITEM_TYPE.menu) {
        return;
      }

      // Expand the current "navItem" (and child "collapse" item), if it contains a "collapse" menu with a child "link" for "pathName"
      const childCollapseItem = navItem.items.find(collapseItemWithChildPathname(currentPathname));
      if (childCollapseItem) {
        mainActions.expandMenuState({
          menuItemId: navItem.id,
          collapseItemId: childCollapseItem.id,
        });
        return;
      }

      // Expand the current "navItem", if it contains a "link" for "pathName"
      const childLinkItem = navItem.items.find(linkItemWithPathname(currentPathname));
      if (childLinkItem) {
        mainActions.expandMenuItem(navItem.id);
        return;
      }

      // If we have a "last" location, expand the "navItem", that contains a "link" for "lastPathname"
      //   For example, when user comes from "Analytics" views back to "Dashboard" we want to expand the "Content Intelligence" menu
      if (lastPathname) {
        const lastChildLinkItem = navItem.items.find(linkItemWithPathname(lastPathname));
        if (lastChildLinkItem) {
          mainActions.expandMenuItem(navItem.id);
        }
      }
    });
  }, [navigationItems, currentPathname, lastPathname, mainActions]);
};

const linkItemWithPathname = (pathName) => (menuItem) =>
  menuItem.type === ITEM_TYPE.link && pathName.startsWith(menuItem.path);

const collapseItemWithChildPathname = (pathName) => (menuItem) =>
  isSubmenuItemType(menuItem.type) && menuItem.items.some(linkItemWithPathname(pathName));
